import React, { useEffect, useRef, useState } from "react";
import Label from "./Label";
import TwoLabel from "./TwoLabel";
import style from "./Dropdown.module.css";
import useSwipeScroll from "../../hooks/useHorizontalScroll";

const Dropdown = ({
    name,
    styles,
    className,
    array,
    Multiple,
    setState,
    Searchable,
    defaultValue,
    placeHolder = "انتخاب ...",
    towLabel,
    label,
    disabled = false,
    required = false,
}) => {
    const [showMenu, setShowMenu] = useState(false);
    const [selectedValue, setSelectedValue] = useState(Multiple ? [] : null);
    const [searchValue, setSearchValue] = useState("");
    const scrollRef = useSwipeScroll();
    const searchRef = useRef();
    const inputRef = useRef();

    useEffect(() => {
        setSearchValue("");
        if (showMenu && searchRef.current) searchRef.current.focus();
    }, [showMenu]);

    useEffect(() => {
        if (defaultValue) {
            if (Multiple) setSelectedValue(filterByReference(array, defaultValue))
            else {
                const data = array.find(el => el.value === defaultValue)
                setSelectedValue(data || null)
            }
        } else if (required && array.length > 0) {
            if (Multiple) {
                const initialValue = [array[0]];
                setSelectedValue(initialValue);
                setState(name, initialValue);
            } else {
                const initialValue = array[0];
                setSelectedValue(initialValue);
                setState(name, initialValue.value, initialValue.name);
            }
        } else setSelectedValue(Multiple ? [] : null)
        window.addEventListener("click", handler);
        return () => window.removeEventListener("click", handler);
    }, [defaultValue, required, array]);

    useEffect(() => {
        if (Multiple) {
            if (!defaultValue && !filterByReference(array, selectedValue).length && !required) setSelectedValue([])
        } else if (!defaultValue && !array.find(i => i.value === selectedValue?.value) && !required) setSelectedValue(null)
    }, [array])

    const filterByReference = (arr1, arr2) => {
        return arr1.filter(el =>
            arr2.find(element => element.value == el.value)
        );
    };

    const handler = (e) => {
        if (inputRef.current && !inputRef.current.contains(e.target)) {
            setShowMenu(false);
        }
    };
    const handleInputClick = () => {
        setShowMenu(!showMenu);
    };

    const getDisplay = () => {
        if (!selectedValue || selectedValue.length === 0) return placeHolder;

        if (Multiple) {
            return (
                <div className={style.dropdown_tags}>
                    {selectedValue.map((option) => (
                        <div key={option.value} className={style.dropdown_tag_item}>
                            {option.name}
                            <span
                                onClick={(e) => onTagRemove(e, option)}
                                className={style.dropdown_tag_close}
                            >
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="m289.94 256 95-95A24 24 0 0 0 351 127l-95 95-95-95a24 24 0 0 0-34 34l95 95-95 95a24 24 0 1 0 34 34l95-95 95 95a24 24 0 0 0 34-34z"></path></svg>
                            </span>
                        </div>
                    ))}
                </div>
            );
        }
        return selectedValue.name;
    };

    const removeOption = (option) => {
        return selectedValue.filter((o) => o.value !== option.value);
    };

    const onTagRemove = (e, option) => {
        e.stopPropagation();
        const newValue = removeOption(option);
        setSelectedValue(newValue);
        setState(name, newValue);
    };

    const onItemClick = (option, name) => {
        let newValue;
        if (Multiple) {
            if (selectedValue.findIndex((o) => o.value === option.value) >= 0) {
                newValue = removeOption(option);
            } else {
                newValue = [...selectedValue, option];
            }
            if (newValue.length === 0 && required) {
                newValue = [option];
            }
        } else {
            newValue = selectedValue !== null && option.value === selectedValue.value ? null : option;
            if (newValue === null && required) newValue = option;
        }
        setSelectedValue(newValue);
        const isArray = Array.isArray(newValue)
        setState(name, isArray ? newValue : newValue?.value, !isArray ? newValue?.name : undefined);
    };

    const isSelected = (option) => {
        if (Multiple) return selectedValue.some((o) => o.value === option.value);
        return selectedValue?.value === option.value;
    };

    const onSearch = (e) => {
        setSearchValue(e.target.value);
    };

    const getOptions = () => {
        if (!searchValue) {
            return array;
        }

        return array.filter(option =>
            Object.values(option).some(val =>
                String(val).toLowerCase().includes(searchValue.toLowerCase())
            )
        );
    };

    return (
        <div className={disabled ? style.disabledDropdown : style.dropdown_container} style={styles ? styles : null}>
            <div>
                <section ref={inputRef} onClick={handleInputClick}
                    className={`${style.dropdown_input} ${className || ' '}`}>
                    <div className={style.dropdown_selected_value} ref={scrollRef}>{getDisplay()}</div>
                    <div className={style.dropdown_tools} style={showMenu ? { transform: 'rotate(180deg)' } : null}>
                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="m112 184 144 144 144-144"></path></svg>
                    </div>
                </section>
                {showMenu && (
                    <div className={style.dropdown_menu}>
                        {Searchable && (
                            <div className={style.search_box}>
                                <input onChange={onSearch} value={searchValue} ref={searchRef}
                                    onClick={e => e.stopPropagation()} />
                            </div>
                        )}
                        <ul className={style.dropdown_item_group} dir="auto">
                            {getOptions().map((option) => (
                                <li
                                    onClick={() => onItemClick(option, name)}
                                    key={option.value}
                                    className={style.dropdown_item}
                                >
                                    <label className={style.gqIo}>
                                        <input type="checkbox" hidden
                                            defaultChecked={isSelected(option) ? true : false} />
                                        <span className={style.gbPol}><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg></span>
                                        <div className={style.Mdsp}>
                                            {towLabel && <TwoLabel one={option.name} two={option.value} />}
                                            {label && <Label name={option.name} />}
                                        </div>
                                    </label>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
};

export default React.memo(Dropdown);